import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogData } from './confirmation-dialog/confirmation-dialog-data.type';
import { Dialog } from './dialog.interface';
import { DialogConfig } from './dialog-config.type';

@Injectable({ providedIn: 'root' })
export class DialogService {
  private dialog = inject(MatDialog);

  openConfirmationDialog(
    data: ConfirmationDialogData,
  ): Dialog<ConfirmationDialogComponent, boolean> {
    return this.dialog.open(ConfirmationDialogComponent, { data });
  }

  openDialog<Component, Data = unknown, Result = unknown>(
    component: ComponentType<Component>,
    config?: DialogConfig<Data>,
  ): Dialog<Component, Result> {
    return this.dialog.open(component, config);
  }

  openFullScreenDialog<Component, Data = unknown, Result = unknown>(
    component: ComponentType<Component>,
    config?: DialogConfig<Data>,
  ): Dialog<Component, Result> {
    return this.dialog.open(component, {
      ...config,
      panelClass: 'full-screen',
    });
  }

  openFullScreenFlexibleDialog<Component, Data = unknown, Result = unknown>(
    component: ComponentType<Component>,
    config?: DialogConfig<Data>,
  ): Dialog<Component, Result> {
    return this.dialog.open(component, {
      ...config,
      panelClass: 'full-screen-flexible',
    });
  }

  openFullScreenLargeDialog<Component, Data = unknown, Result = unknown>(
    component: ComponentType<Component>,
    config?: DialogConfig<Data>,
  ): Dialog<Component, Result> {
    return this.dialog.open(component, {
      ...config,
      panelClass: 'full-screen-large',
    });
  }
}
